import React from 'react';
import cx from 'classnames';

import styles from './CheckboxOptionItem.module.scss';

import CheckboxItem, { CheckboxItemProps } from '../../atoms/CheckboxItem';
import Divider, { DividerProps } from '../../atoms/Divider';
import TextInput, { TextInputProps } from '../../atoms/TextInput';
import Select, { SelectProps } from '../../atoms/Select';
import Text, { TextProps } from '../../atoms/Text';

export type CheckboxOptionItemStateType =
  | 'Default'
  | 'Selected'
  | 'SelectedZero'
  | 'Error';
export type CheckboxOptionItemTypeType =
  | 'Default'
  | 'TextField'
  | 'SelectField';

export const defaultProps = {
  state: 'Default' as CheckboxOptionItemStateType,
  type: 'SelectField' as CheckboxOptionItemTypeType,
  checkboxItem: {
    type: 'Default',
    state: 'Unselected',
    icon: {
      asset: 'CheckboxUnchecked',
      style: 'Green800',
    },
    label: {
      type: 'Body2',
      align: 'Left',
      style: 'Grey1100',
    },
    trailingText: {
      type: 'Body2',
      align: 'Right',
      style: 'Grey700',
    } as TextProps,
  } as CheckboxItemProps,
  divider: {
    type: 'HorizontalSolid',
    style: 'Grey400',
  } as DividerProps,
  textInput: {
    type: 'Text',
    style: 'Default',
  } as TextInputProps,
  select: {
    text: {
      type: 'Body2',
      align: 'Left',
      style: 'Grey1100',
    },
    icon: {
      asset: 'ChevronDown',
      style: 'Grey1100',
    },
  } as SelectProps,
  errorText: {
    type: 'Body2',
    align: 'Left',
    style: 'Red800',
  } as TextProps,
};

export type CheckboxOptionItemProps = {
  state?: CheckboxOptionItemStateType;
  type?: CheckboxOptionItemTypeType;
  checkboxItem?: CheckboxItemProps;
  divider?: DividerProps;
  className?: string;
  textInput?: TextInputProps;
  select?: SelectProps;
  errorText?: TextProps;
};

const CheckboxOptionItem: React.FC<CheckboxOptionItemProps> = ({
  state,
  type,
  checkboxItem,
  divider,
  className,
  textInput,
  select,
  errorText,
}) => {
  const currentStyle = styles[`checkboxOptionItem${type}`];

  const dividerView = <Divider className={styles.divider} {...divider} />;

  const errorView =
    state === 'Error' ? (
      <Text className={styles.errorText} {...errorText} />
    ) : undefined;

  const textInputView =
    checkboxItem?.state === 'Selected' ||
    checkboxItem?.state === 'SelectedZero' ? (
      <TextInput className={styles.textInput} {...textInput} />
    ) : null;

  let contentView;

  switch (type) {
    case 'Default':
      contentView = (
        <div className={styles.content}>
          <CheckboxItem className={styles.checkboxItem} {...checkboxItem} />
        </div>
      );
      break;
    case 'TextField':
      contentView = (
        <div className={styles.content}>
          <CheckboxItem className={styles.checkboxItem} {...checkboxItem} />
          {textInputView}
          {errorView}
        </div>
      );
      break;
    case 'SelectField':
      contentView = (
        <div className={styles.content}>
          <CheckboxItem className={styles.checkboxItem} {...checkboxItem} />
          <Select className={styles.select} {...select} />
          {errorView}
        </div>
      );
      break;
  }

  return (
    <div className={cx(currentStyle, className)}>
      {contentView}
      {dividerView}
    </div>
  );
};

CheckboxOptionItem.defaultProps = defaultProps;

export default CheckboxOptionItem;
